module.exports = __webpack_public_path__ + "img/employment.b18b1581.png";